import { Space, Typography } from 'antd'
import React from 'react'

const TitleHead = ({ h1, h2, extra }) => {

    const { Title, Text } = Typography;

    return (
        <div style={{ margin: 14 }}>
            <Title level={4} style={{ margin: 0, color: '#1e293b', fontWeight: 700 }}>
                <Space>
                    {h1}
                    {extra}
                </Space>
            </Title>
            <Text type="secondary" style={{ fontSize: 14 }}>
                {h2}
            </Text>




        </div>
    )
}

export default TitleHead
